module.exports = __webpack_public_path__ + "static/credit.8a0dab7b.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/credit.png
// module id = 1006
// module chunks = 2